export const getWeillCornell = (state) =>
  state?.variantResult?.weill_cornell_medicine_pmkb;
export const getWustlCivic = (state) => state?.variantResult?.wustl_civic;
export const getWustlDoCM = (state) => state?.variantResult?.wustl_docm;
export const getJaxCkb = (state) => state?.variantResult?.jax_ckb;
export const getPubMedArticlesFromStore = (state) =>
  state?.variantResult?.publications?.publications;
